export default {
    formElement: {
        display: 'block',
        marginBottom: '20px',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '40px',
    },
    cardActionStyle: {
        zIndex: 2,
        display: 'inline-block',
        float: 'right',
    },
};



// WEBPACK FOOTER //
// ./src/pages/products/productProperties/edit/styles.js